<template>
    <div v-if="!auth.isAuthenticated">        
        <router-link class="px-3 py-2 bg-sky-500 text-white rounded-lg" to="/login">
            Login
        </router-link>
    </div>
    <div v-else>
        <DropdownMenu align="right" :close-on-select="true" @select="onSelect">
            <template #trigger>
                <span class="font-semibold">Sa tra' {{ username }}</span>
            </template>


            <DropdownItem class="text-gray-500 
                hover:bg-sky-500 hover:text-gray-50
                " value="account">Account...</DropdownItem>
            <DropdownItem class="text-gray-500 
                hover:bg-sky-500 hover:text-gray-50
                " value="logout">Logout</DropdownItem>
        </DropdownMenu>
    </div>
</template>

<script setup>
    import { useRouter } from 'vue-router'
    import { computed } from 'vue'
    import { useAuthStore } from '@/stores/auth.js'
    
    import DropdownMenu from './dropdown/DropdownMenu.vue'
    import DropdownItem from './dropdown/DropdownItem.vue'

    const auth = useAuthStore()
    const router = useRouter()
    
    const username = computed(() => {
        const user = auth.getUser
        if (!user) {
            return 'x'
        }
        return user.username
    })

    function doLogout() {
        auth.logout()
        router.replace('/login') // redirect imediat spre login
    }

    function onSelect(context) {
        switch (context) {
            case 'account':
                router.replace('/account') // redirect imediat spre account
                break;
            case 'logout':
                auth.logout()
                router.replace('/login') // redirect imediat spre login
                break;
            default:
                break;
        }
    }
</script>